import React, { memo } from "react";
import { css } from "goober";

import getTraitIconURL from "@/game-tft/get-trait-icon.mjs";
import HexIconMap from "@/game-tft/hex-icon-map.mjs";
import { TypeIconFrame } from "@/game-tft/TraitIcon.style.jsx";
import TypeHex from "@/inline-assets/type-hex.svg";

function TypeIcon({ name = "", size, traitMetColor, count, ...rest }) {
  const HexIcon = HexIconMap[traitMetColor] ?? HexIconMap.bronze;
  const type = traitMetColor ? "dark" : "light";

  return (
    <TypeIconFrame
      name={name}
      style={size && { "--size": `${size}px` }}
      {...rest}
    >
      <img
        src={getTraitIconURL(name, type)}
        alt="trait-icon"
        style={size && { "--size": `${size - 6}px` }}
      />
      {count ? (
        <div className="countLabel type-caption shade1">{`x${count}`}</div>
      ) : (
        ""
      )}
      {traitMetColor ? (
        <HexIcon style={size && { "--size": `${size}px` }} />
      ) : (
        <TypeHex
          className={css`
            * {
              fill: transparent;
            }
          `}
        />
      )}
    </TypeIconFrame>
  );
}

export default memo(TypeIcon);
